import { CHOICE, plural } from '../lib/labels.ts';
import type { Choice, VotingView } from '../lib/types.ts';

const COLOR: Record<Choice, string> = { for: 'var(--for)', against: 'var(--against)', abstain: 'var(--abstain)' };

/** Barras de conteo sobre los presentes, con la marca del mínimo para aprobar al cerrar. */
export function Tally({ voting, present }: { voting: VotingView | null; present: number }) {
  const D = Math.max(1, present);
  const tally = voting?.tally ?? null;
  const pending = voting ? Math.max(0, present - voting.ballotsCast) : 0;
  // El mínimo es el de la mayoría: sin quórum no aplica y la marca confundiría.
  const need = voting?.result?.status === 'no-quorum' ? undefined : voting?.result?.need;
  const markPos = need !== undefined ? Math.min(100, (need / D) * 100) : null;
  return (
    <div class="tally" aria-live="polite">
      {(['for', 'against', 'abstain'] as const).map((c, i) => (
        <>
          <span>{CHOICE[c]}</span>
          <div class="track">
            <div class="fill" style={{ width: `${tally ? (tally[c] / D) * 100 : 0}%`, background: COLOR[c] }} />
            {i === 0 && markPos !== null && (
              <>
                <div class="mark" style={{ left: `${markPos}%` }} />
                <div class="markl" style={{ left: `${Math.min(92, Math.max(8, markPos))}%` }}>mínimo {need}</div>
              </>
            )}
          </div>
          <span class="count">{tally ? tally[c] : '·'}</span>
        </>
      ))}
      <span>Sin votar</span>
      <div class="track"><div class="fill" style={{ width: `${(pending / D) * 100}%`, background: 'var(--line)' }} /></div>
      <span class="count">{pending}</span>
      {voting && !tally && <span class="hint" style={{ gridColumn: '1 / -1' }}>Votación secreta: el conteo se muestra al cerrar.</span>}
    </div>
  );
}

export function Result({ voting }: { voting: VotingView }) {
  const r = voting.result;
  if (!r) return null;
  return (
    <div class="result">
      <p>{r.reason}</p>
      <p class="meta">{r.status === 'no-quorum' ? '' : `Base ${r.base}, mínimo ${r.need}. `}{plural(r.ballots, 'voto', 'votos')}. Reglas {voting.rulesVersion}{voting.casting ? `. Voto de calidad: ${CHOICE[voting.casting].toLowerCase()}` : ''}.</p>
    </div>
  );
}
